import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class GlobalSettingsService {
  private readonly apiService = inject(BaseApiService);

  async getClientSettings() {
    return await this.apiService.get(`/global-settings`);
  }
}
